import type { RouterConfig } from '@nuxt/schema';
import { createWebHistory } from 'vue-router';

/**
 * 라우트 경로 변환: /screens/* → /*
 * - /screens/task/home → /task/home (메인 경로)
 * - /screens/task/home도 alias로 유지 (호환성)
 *
 * history: Vue Router base를 baseURL과 동일하게 설정
 * - 프로덕션: /app (NUXT_APP_BASE_URL)
 * - 개발: /
 */
export default <RouterConfig>{
  history: base => createWebHistory(base),
  routes: _routes => {
    const routes = _routes;

    const processRoutes = (routeList: typeof routes) => {
      routeList.forEach(route => {
        if (route.path.startsWith('/screens/')) {
          const originalPath = route.path;
          const cleanPath = route.path.replace(/^\/screens/, '') || '/';

          // alias 설정
          if (!route.alias) {
            route.alias = [];
          } else if (typeof route.alias === 'string') {
            route.alias = [route.alias];
          }
          if (!route.alias.includes(originalPath)) {
            (route.alias as string[]).push(originalPath);
          }

          // 메인 경로 변경
          route.path = cleanPath;
        }

        // 중첩 라우트 처리
        if (route.children) {
          processRoutes(route.children);
        }
      });
    };

    processRoutes(routes);
    return routes;
  },
};
